import { ComponentRef, Directive, inject, Input, OnInit, ViewContainerRef } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { DynamicFormComponent } from "../../containers/dynamic-form/dynamic-form.component";
import { DFormControl } from "../../entities/form-control";
import { FormField } from "../../entities/form-field";
import { DFormGroup } from "../../entities/form-group";
import { DynamicFormsFactory } from "../../services/dynamic-forms.factory";
import * as utils from "../../utils/utils";
import { FormGroupComponent } from "../form-group/form-group.component";

@Directive({
	selector: "[dynamicField]",
	standalone: false,
})
export class DynamicFieldDirective implements OnInit {
	private factory = inject(DynamicFormsFactory);
	private container = inject(ViewContainerRef);

	@Input() config: DFormControl | DFormGroup;
	@Input() group: UntypedFormGroup;

	component: ComponentRef<FormField | FormGroupComponent | DynamicFormComponent>;

	ngOnInit() {
		if (utils.isGroup(this.config)) {
			this.component = this.factory.createGroup(this.container, this.config, this.group);
		} else {
			this.component = this.factory.createComponent(this.container, this.config, this.group);
		}
	}
}
